import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router';
import { useTitle } from 'react-use';

import ErrorBoundary from '@/components/templates/ErrorBoundary';
import RouteElement from '@/components/templates/Routes/RouteElement';
import { selectIsAuthenticated } from '@/redux/user/selectors';

import { AcceptInvitationPage } from './pages/AcceptInvitationPage/AcceptInvitationPage';
import { WelcomePage } from './pages/WelcomePage/WelcomePage';

export const InvitationRouter = () => {
  const { t } = useTranslation();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  useTitle(t('member_invitation.invitation'));

  // If user is authenticated, redirect to the merged profile page (invitations section)
  if (isAuthenticated) {
    return <Navigate to="/profile/information" replace />;
  }

  return (
    <Routes>
      {/* Default route for /invitations */}
      <Route
        path="/"
        element={
          <ErrorBoundary>
            <AcceptInvitationPage />
          </ErrorBoundary>
        }
      />
      <Route path="/welcome" element={<RouteElement comp={WelcomePage} />} />
    </Routes>
  );
};
